import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

const ImageModal: React.FC<{
  src: string;
  open: boolean;
  toggle: () => void;
}> = ({ src, open, toggle }) => {
  return (
    <>
      <Modal
        isOpen={open}
        className="ss-modal"
        size="lg"
        toggle={toggle}
      >
        <ModalHeader>
          Image
        </ModalHeader>
        <ModalBody style={{
          maxHeight: 'calc(100vh - 100px)',
          maxWidth: 'calc(100vw - 100px)',
          overflowY: 'auto',
          overflowX: 'auto',
        }}>
          <img
            src={src}
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
            }}
            alt='...'
          />
        </ModalBody>
      </Modal>
    </>
  )
}

export default ImageModal
